"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import posthog from "posthog-js";
import { isPostHogSuppressedPath } from "@/lib/posthog-suppressed-path";

/**
 * Stoppt Session Recording auf Admin-Routen und nimmt es nach Verlassen wieder auf
 * (posthog-js bleibt initialisiert, damit Soft-Navigation Admin → Shop weiter funktioniert).
 */
export function PostHogAdminRouteGate() {
	const pathname = usePathname() ?? "";
	const wasSuppressedRef = useRef(false);

	useEffect(() => {
		if (!posthog.__loaded) {
			return;
		}

		const suppressed = isPostHogSuppressedPath(pathname);

		if (suppressed) {
			try {
				posthog.stopSessionRecording();
			} catch {
				// ignore
			}
			wasSuppressedRef.current = true;
			return;
		}

		if (wasSuppressedRef.current) {
			wasSuppressedRef.current = false;
			try {
				posthog.startSessionRecording();
			} catch {
				// ignore
			}
		}
	}, [pathname]);

	return null;
}
